<button
    (click)='previousPage()'
    class='btn btn-default wizardBtn'
    [attr.disabled]='!hasPreviousPage()?true:null'
> &lt; </button>
<div class='wizardContent'>
    <span *ngFor='let fieldset of schema.fieldsets; let i=index'>
        <fieldset *ngIf='currentPage === i'>
            <legend *ngIf='fieldset.title'>{{fieldset.title}}</legend>
            <sf-form-element
                *ngFor='let fieldId of fieldset.fields'
                [formProperty]='formProperty.getProperty(fieldId)'
            >
            </sf-form-element>
        </fieldset>
    </span>
</div>
<button
    (click)='nextPage()'
    class='btn btn-default wizardBtn'
    [attr.disabled]='!hasNextPage()?true:null'
> &gt; </button>
